export const NICKNAME_REGEX = /^[-._a-zA-Z0-9]{2,35}$/;
